<template>
  <footer class="h5 h5-esign-footer-wrapper">
    <!-- 服务热线 start -->
    <div class="about-us">
      <ul class="h5-hotline-wrapper">
        <li v-for="(item, index) in hotline" :key="index" class="item-wrapper">
          <a :href="item.url" :class="`item item-${item.id}`"
            ><i class="icon" :style="item.iconUrl ? { backgroundImage: `url(${item.iconUrl})` } : {}" /><span
              :class="`desc desc-${item.id}`"
              >{{ item.desc }}：</span
            >{{ item.title }}</a
          >
        </li>

        <!-- 其他社交软件联系方式 start -->
        <li class="item-wrapper other-line-wrapper" id="footup">
          <div class="other-line-title">关于我们</div>
          <div class="other-line">
            <div
              v-for="(item, index) in otherLine"
              :key="index"
              class="ol-item"
              @mouseover="handleMouseover(item.id)"
              @mouseout="handelMouseout()"
              @click="handleClick(item.id)"
            >
              <div class="ol-icon" :title="item.title"><img :src="current === item.id ? item.activeImgUrl : item.imgUrl" /></div>
              <div v-show="current === item.id" class="ol-code" @mouseover="handleMouseover(item.id)" @mouseout="handelMouseout()">
                <img :src="item.code" />
              </div>
            </div>
          </div>
        </li>
        <!-- 其他社交软件联系方式 end -->
      </ul>
    </div>
    <!-- 服务热线 end -->
    <div class="footer-bottom">
      <!-- 备案号 -->
      <p class="row" v-html="siteConfigBanquan"></p>

      <!-- 服务协议 -->
      <div class="row agreement-link">
        <a v-for="link in agreementLink" :key="link.url" class="link" :href="link.url" rel="nofollow">{{ link.title }}</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    hotline: {
      type: Array,
      default() {
        return []
      },
    },
    otherLine: {
      type: Array,
      default() {
        return []
      },
    },
    agreementLink: {
      type: Array,
      default() {
        return []
      },
    },
    siteConfigBanquan: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      current: '',
      timer: null,
    }
  },
  methods: {
    handleClick(id) {
      this.current = id
    },
    handleMouseover(current) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.current = current
    },
    handelMouseout() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.current = ''
      }, 300)
    },
  },
}
</script>

<style lang="less" scoped>
.hotline-wrapper,
.h5-hotline-wrapper {
  .icon {
    display: inline-block;
    width: 0.3733rem;
    height: 0.3733rem;
    margin-right: 0.16rem;
    vertical-align: -0.1em;
  }
  .item-kefu-tel,
  .item-sale-tel {
    .icon {
      background: url('../../assets/images/new-footer/icon-grey-tel.png') no-repeat center;
      background-size: 100%;
    }
  }
  .item-business-mail {
    .icon {
      background: url('../../assets/images/new-footer/icon-handshake.png') no-repeat center;
      background-size: 100%;
    }
  }
  .item-ceo-mail {
    .icon {
      background: url('../../assets/images/new-footer/icon-mail.png') no-repeat center;
      background-size: 100%;
    }
  }
}
.other-line {
  .ol-icon {
    width: 0.8533rem;
    height: 0.8533rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .ol-code {
    position: absolute;
    width: 3.4667rem;
    height: 3.4667rem;
    background: #fff;
    top: 1.3067rem;
    &::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: -0.2133rem;
      left: 0.2133rem;
      border: 0.1867rem solid transparent;
      border-top: 0;
      border-bottom: 0.2133rem solid #fff;
    }
    img {
      width: 100%;
    }
  }
}

.h5-esign-footer-wrapper {
  width: 100%;
  padding: 0.88rem 0.32rem 0.96rem;
  background: #242424;
}

.h5-hotline-wrapper {
  width: 100%;
  padding: 0 0.4267rem;

  .item-wrapper {
    width: 100%;
    padding: 0.32rem 0.16rem;
    margin-bottom: 0.2133rem;
    font-size: 0.3733rem;
    color: #999;
    line-height: 0.5333rem;
    border: 0.0267rem solid #4e4e4e;
    text-align: center;
  }
  .desc {
    font-size: 0.3733rem;
    font-weight: 400;
    color: #999;
    line-height: 0.5333rem;
  }
  .item {
    display: inline-block;
    width: 6.1333rem;
    font-size: 0.3733rem;
    font-weight: 600;
    color: #fff;
    line-height: 0.5333rem;
    text-align: left;
  }
  .other-line-wrapper {
    border: none;
  }
  .other-line-title {
    margin-bottom: 0.5333rem;
  }
  .other-line {
    position: relative;
    display: flex;
    justify-content: space-evenly;
  }
}

.footer-bottom {
  text-align: center;
  color: #999999;
  line-height: 0.4533rem;
  font-size: 0.32rem;
  background: #242424;
  padding: 0.5333rem 0.32rem 1.0667rem;
  /deep/ a {
    color: #999;
    font-size: 0.32rem;
    &:hover {
      color: #fff;
    }
  }
  .row {
    font-size: 0.32rem;
    margin-bottom: 0.3733rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .link {
    color: #999;
    font-size: 0.32rem;
    &::after {
      content: ' | ';
    }
    &:last-child {
      &::after {
        content: '';
      }
    }
  }
}
</style>
